import React, { FunctionComponent, useContext } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LoginFormButton } from "./form-components/login-form-button";
import { LoginFormTextField } from "./form-components/login-form-textfield";
import { LoginContext } from "./context/login-context";
import { useEnterCallback } from "../../hooks/use-enter-callback";

interface ILoginFormProps {}

export const LoginForm: FunctionComponent<ILoginFormProps> = (props) => {
  const { t } = useTranslation();
  const {
    email,
    password,
    isEmailValid,
    isPasswordValid,
    onLogin,
    loginLoading,
    onPasswordChange,
    onEmailChange,
  } = useContext(LoginContext);

  const onKeyDown = useEnterCallback(onLogin);

  return (
    <>
      <Grid container direction="column">
        <LoginFormTextField
          label={t("login.fields.email")}
          type="email"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          error={isEmailValid}
          onKeyDown={onKeyDown}
        />

        <LoginFormTextField
          label={t("login.fields.password")}
          type="password"
          value={password}
          onChange={(event) => onPasswordChange(event.target.value)}
          error={isPasswordValid}
          onKeyDown={onKeyDown}
        />
      </Grid>
      <Grid container justify="center">
        <LoginFormButton onClick={onLogin} loading={loginLoading}>
          {t("login.log_in")}
        </LoginFormButton>
      </Grid>
    </>
  );
};
